import { useState, type FormEvent } from "react";
import { HttpError } from "../../lib/api-client.js";
import { useLogin } from "./useAuth.js";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const login = useLogin();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    login.mutate({ email: email.trim(), password });
  };

  const errMsg =
    login.error instanceof HttpError && login.error.status === 401
      ? "Invalid email or password."
      : login.error
        ? String(login.error.message ?? login.error)
        : null;

  return (
    <div
      style={{
        minHeight: "calc(100vh - 60px)",
        display: "grid",
        placeItems: "center",
      }}
    >
      <form
        onSubmit={onSubmit}
        className="panel login-form"
        style={{
          margin: 0,
          padding: 24,
          width: 360,
          maxWidth: "calc(100vw - 24px)",
          display: "grid",
          gap: 12,
        }}
      >
        <div style={{ fontWeight: 700, fontSize: 16 }}>Sign in</div>
        <label style={{ display: "grid", gap: 4 }}>
          <span style={{ color: "var(--muted)", fontSize: 12 }}>Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
            autoFocus
            style={inputStyle}
          />
        </label>
        <label style={{ display: "grid", gap: 4 }}>
          <span style={{ color: "var(--muted)", fontSize: 12 }}>Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            style={inputStyle}
          />
        </label>
        {errMsg && (
          <div style={{ color: "var(--err)", fontSize: 13 }}>{errMsg}</div>
        )}
        <button
          type="submit"
          disabled={login.isPending}
          style={buttonStyle}
        >
          {login.isPending ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  background: "var(--bg)",
  color: "var(--text)",
  border: "1px solid var(--border)",
  borderRadius: 4,
  padding: "8px 10px",
  fontSize: 14,
  fontFamily: "inherit",
};

const buttonStyle: React.CSSProperties = {
  background: "var(--accent)",
  color: "#0e1116",
  border: "none",
  borderRadius: 4,
  padding: "10px 14px",
  fontSize: 14,
  fontWeight: 600,
  cursor: "pointer",
};
